import { render, staticRenderFns } from "./OpenInNewIcon.vue?vue&type=template&id=0ea7f611&scoped=true&"
import script from "./OpenInNewIcon.vue?vue&type=script&lang=js&"
export * from "./OpenInNewIcon.vue?vue&type=script&lang=js&"
import style0 from "./OpenInNewIcon.vue?vue&type=style&index=0&id=0ea7f611&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea7f611",
  null
  
)

export default component.exports